import Image from 'next/image'
import React, { useContext } from 'react'

// styles
import styles from './TermsConditions.module.scss'

// asset
import termsConditions from '@/../public/img/termsConditions.png'
import { NavLink } from '@/components/atoms/NavLink/NavLink'
import Btn from '@/components/atoms/Btn/Btn'
import { TermsCondContext } from '@/context/guest/TermsCond'

const TermsConditions = () => {
  const { terms } = useContext(TermsCondContext)
  return (
    <div className={styles.containes}>
      <div className={styles.body_section}>
        <div className={styles.image_container}>
          <Image
            src={termsConditions}
            className={styles.logo1}
            alt='Picture of the author '
            width={690}
            height={519}
          />
        </div>
        <div className={styles.title_container}>
          <h2 className={styles.title1}>Términos <br className={styles.break} /> y <br className={styles.break} /> condiciones</h2>
        </div>
      </div>
      <div className={styles.conTerms}>
        <div className={styles.card}>
          <p dangerouslySetInnerHTML={{ __html: terms }} />
          <div className={styles.btnSection}>
            <div className={styles.mr_36}>
              <NavLink href='/register' name={<Btn className='btnBlack'>Volver</Btn>} />
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default TermsConditions
